import { Paper, PaperProps } from '@mantine/core';
import { ReactNode } from 'react';

interface CardProps extends PaperProps {
  children: ReactNode;
}

export function Card({ children, ...rest }: CardProps) {
  return (
    <Paper shadow="sm" radius="md" p="xl" withBorder {...rest}>
      {children}
    </Paper>
  );
}
